import { render, staticRenderFns } from "./PartnerLogosModule.vue?vue&type=template&id=7105f704&scoped=true"
import script from "./PartnerLogosModule.vue?vue&type=script&lang=js"
export * from "./PartnerLogosModule.vue?vue&type=script&lang=js"
import style0 from "./PartnerLogosModule.vue?vue&type=style&index=0&id=7105f704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7105f704",
  null
  
)

export default component.exports